import { WavesOne, WavesTwo } from './WavesOne';
import TrianglesOne from './TrianglesOne';
import ZigZag from './ZigZag';
import ZigZagRounded from './ZigZagRounded';
import Arc from './Arc';
import ArcInverted from './ArcInverted';
import Diagonal from './Diagonal';

const shapes = {
  'waves-1': WavesOne,
  'waves-2': WavesTwo,
  'triangles-1': TrianglesOne,
  'zig-zag': ZigZag,
  'zig-zag-rounded': ZigZagRounded,
  'arc-1': Arc,
  'arc-inverted-1': ArcInverted,
  'diagonal-1': Diagonal,
};

export type ShapeKeys = keyof typeof shapes;

interface Props {
  shape: ShapeKeys;
  color?: string;
  scale?: number;
}

const Shapes = (props: Props) => {
  if (shapes[props.shape]) {
    const Shape = shapes[props.shape];
    return <Shape {...props} />;
  }

  return null;
};

export default Shapes;
